import { Button, Timeline } from 'antd';
import { useNavigate } from 'react-router';
import IMAGES from '@/assets/images';
import CustomImage from '@/components/CustomImage';
import useAuth from '@/hooks/useAuth';
import AuthLayout, {
  TimelineContent,
  TimelineIcon,
} from '@/layouts/AuthLayout';
import BasicInfoIcon from './SelfOnboard/_icons/BasicInfoIcon';
import PaymentIcon from './SelfOnboard/_icons/PaymentIcon';
import PlanInfoIcon from './SelfOnboard/_icons/PlanInfoIcon';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { verifiedInfo } = useAuth();

  const handleGoToDashboard = () => {
    if (verifiedInfo?.id) {
      navigate('/admin/employee/dashboard', { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  };
  const items = [
    {
      dot: <TimelineIcon isActive={true} Icon={BasicInfoIcon} />,
      children: (
        <TimelineContent
          title="Basic Info"
          subtitle="Company Basic information"
        />
      ),
    },
    {
      dot: <TimelineIcon isActive={true} Icon={PlanInfoIcon} />,
      children: (
        <TimelineContent title="Subscriptions" subtitle="Select Plan" />
      ),
    },
    {
      dot: <TimelineIcon isActive={true} Icon={PaymentIcon} />,
      children: <TimelineContent title="Payment" subtitle="Payment Status" />,
    },
  ];

  return (
    <AuthLayout
      leftContent={
        <>
          <div className="mt-2 w-full flex justify-center z-10">
            <CustomImage
              alt="main_logo"
              src={IMAGES.mainLogo}
              className="w-40 h-24"
            />
          </div>
          <Timeline className="onboard-timeline z-10" items={items} />
        </>
      }
    >
      <div className="flex flex-col items-center justify-center h-full">
        <CustomImage width={100} height={100} src={IMAGES.paymentSuccess} />
        <div className="text-center">
          <h1 className="text-3xl text-white font-bold mb-4">
            Payment Successful
          </h1>
          <p className="text-white text-lg max-w-sm">
            Thank you for your payment. Your transaction has been completed
            successfully.
          </p>
          <Button
            onClick={handleGoToDashboard}
            className="mt-4 btn-primary h-11"
            size="large"
          >
            Go to Dashboard
          </Button>
        </div>
      </div>
    </AuthLayout>
  );
};

export default PaymentSuccess;
